export const pageView = (url) => {
    if(process.env.NODE_ENV !== "production"){
        return;
    }
    window.gtag('config', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
        page_path: url,
    })
}